import React from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {RootState} from '../../redux/store';
import {useTranslation} from 'react-i18next';
import UserPhoto from './UserPhoto/UserPhoto';
import s from './UserInfo.module.css';

const UserInfo: React.FC = () => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const userData = useSelector((state: RootState) => state.userData.userView);
	const authData = useSelector((state: RootState) => state.userData.authData);
	const session = useSelector((state: RootState) => state.appData.session);

	if (!userData) {
		return null;
	}
	
	const currentUserId = session.user_id ?? authData.user_id;
	
	const handleContractClick = () => {
		if (currentUserId) {
			navigate('/my_team', {
				state: { openClientInfo: currentUserId }
			});
		}
	};
	
	return (
		<div className={s.userItem}>
			<div className={s.userItemColumn}>
				<UserPhoto userName={userData.name || ''} photo={userData.photo} />
				<div className={s.qualificationCircle}>
					{userData.qlfc ?? ''}
				</div>
			</div>
			<div className={s.userItemColumn}>
				<div className={s.itemUserName}>{userData.name ?? ''}</div>
				<button
					type="button"
					className={s.itemUserPhone}
					onClick={handleContractClick}
				>
					<span className={s.itemUserText}>{t('Номер контракту')}:</span>{' '}
					{userData?.contract ?? ''}
				</button>
				<div className={s.itemUserTextQualification}>
					{t('Поточна кваліфікація')}: {userData.qlfc_name ?? ''}
				</div>
				<div className={s.itemUserLabel}>{userData.location ?? ''}</div>
			</div>
		</div>
	);
};

export default UserInfo;
